import {styled} from '@mui/material/styles';
import {FormControl, InputLabel, Select, MenuItem, type SelectProps, type FormControlProps} from '@mui/material';

export const GenericSelect = (props: SelectProps<unknown> & {formControlProps?: FormControlProps}) => {
  const {children, label, formControlProps, ...selectProps} = props;
  return (
    <StyledFormControl {...{...{fullWidth: true, ...formControlProps}}}>
      <InputLabel color="primary">{label}</InputLabel>
      <StyledSelect color="primary" label={label} {...selectProps}>
        {children}
      </StyledSelect>
    </StyledFormControl>
  );
};

export const GenericSelectItem = styled(MenuItem)(({theme}) => ({
  '&.Mui-selected, &.Mui-selected:hover': {
    backgroundColor: theme.palette.background.default,
  },
}));

const StyledSelect = styled(Select)(({theme}) => ({
  '.MuiSelect-select': {
    display: 'flex',
    justifyContent: 'space-between',
    minWidth: theme.spacing(28),
  },
}));

const StyledFormControl = styled(FormControl)(({theme}) => ({
  borderRadius: theme.spacing(0.5),
}));
